import 'vuetify/styles'
import {createVuetify} from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import '@mdi/font/css/materialdesignicons.css'
import * as directives from 'vuetify/directives'
import * as vComponents from 'vuetify/components'
import {VDataTable, VDataTableServer, VDataTableVirtual,} from "vuetify/components/VDataTable";

export default createVuetify({
    theme: {
        defaultTheme: 'light',
        themes: {
            light: {
                colors: {
                    primary: '#26235A',
                    secondary: '#E6038C',
                    // Semantic colors aligned with the live-status palette in
                    // appDesign.js so chips, alerts and buttons stay consistent
                    // and on-brand instead of using Material defaults.
                    success: '#22C55E',
                    info: '#3B82F6',
                    warning: '#F59E0B',
                    error: '#EF4444',
                },
            },
            dark: {
                dark: true,
                colors: {
                    // Lightened brand purple so primary text/icons stay legible
                    // on dark surfaces; gradient buttons keep the navy->magenta.
                    primary: '#9C8FFF',
                    secondary: '#E6038C',
                    background: '#121218',
                    surface: '#1E1E28',
                    success: '#22C55E',
                    info: '#3B82F6',
                    warning: '#F59E0B',
                    error: '#EF4444',
                },
            }
        },
    },
    components: {
        ...vComponents,
        // Vuetify 3 lab components registration
        VDataTable,
        VDataTableServer,
        VDataTableVirtual,
    },
    directives
})
